export enum BillingsOrderForwardTaxiTaxiAddParamsContributionType {
  BASE_AMOUNT = "BASE_AMOUNT",
  CHARGE_HALTING = "CHARGE_HALTING",
  CHARGE_HIGHWAYS = "CHARGE_HIGHWAY",
  BONUS_FAVORABLE_DISTANCE = "BONUS_FAVORABLE_DISTANCE",
  BONUS_OTHER = "BONUS_OTHER",
  PENALTY_WRONG_ROUTE = "PENALTY_WRONG_ROUTE",
  PENALTY_BEING_LATE = "PENALTY_BEING_LATE",
  PENALTY_INCOMPATIBLE_CAR = "PENALTY_INCOMPATIBLE_CAR",
  PENALTY_OTHER = "PENALTY_OTHER",
}

export type BillingsOrderForwardTaxiTaxiAddParamsBonusContributionFavorableDistance =
  {
    type: BillingsOrderForwardTaxiTaxiAddParamsContributionType.BONUS_FAVORABLE_DISTANCE;
    comment: string | null;
    distance: number;
    rate: number;
  };

export type BillingsOrderForwardTaxiTaxiAddParamsBonusContributionOther = {
  type: BillingsOrderForwardTaxiTaxiAddParamsContributionType.BONUS_OTHER;
  comment: string | null;
  amount: number;
};

export type BillingsOrderForwardTaxiTaxiAddParamsPenaltyContributionWrongRoute =
  {
    type: BillingsOrderForwardTaxiTaxiAddParamsContributionType.PENALTY_WRONG_ROUTE;
    comment: string | null;
    amount: number;
  };

export type BillingsOrderForwardTaxiTaxiAddParamsPenaltyContributionBeingLate =
  {
    type: BillingsOrderForwardTaxiTaxiAddParamsContributionType.PENALTY_BEING_LATE;
    comment: string | null;
    amount: number;
  };

export type BillingsOrderForwardTaxiTaxiAddParamsPenaltyContributionIncompatibleCar =
  {
    type: BillingsOrderForwardTaxiTaxiAddParamsContributionType.PENALTY_INCOMPATIBLE_CAR;
    comment: string | null;
    amount: number;
  };

export type BillingsOrderForwardTaxiTaxiAddParamsPenaltyContributionOther = {
  type: BillingsOrderForwardTaxiTaxiAddParamsContributionType.PENALTY_OTHER;
  comment: string | null;
  amount: number;
};

export type BillingsOrderForwardTaxiTaxiAddParamsBonusContribution =
  | BillingsOrderForwardTaxiTaxiAddParamsBonusContributionFavorableDistance
  | BillingsOrderForwardTaxiTaxiAddParamsBonusContributionOther;

export type BillingsOrderForwardTaxiTaxiAddParamsPenaltyContribution =
  | BillingsOrderForwardTaxiTaxiAddParamsPenaltyContributionWrongRoute
  | BillingsOrderForwardTaxiTaxiAddParamsPenaltyContributionBeingLate
  | BillingsOrderForwardTaxiTaxiAddParamsPenaltyContributionIncompatibleCar
  | BillingsOrderForwardTaxiTaxiAddParamsPenaltyContributionOther;

export type BillingsOrderForwardTaxiTaxiAddParamsContribution =
  | BillingsOrderForwardTaxiTaxiAddParamsBonusContribution
  | BillingsOrderForwardTaxiTaxiAddParamsPenaltyContribution;

export type BillingsOrderForwardTaxiTaxiAddParamsBillingNode = {
  id: string;
  nodeId: string;
  lat: number;
  lon: number;
  description: string;
  checkoutDate: Date | null;
  checkoutEventId: string | null;
  plannedDate: Date | null;
  orderId: string | null;
  distance: number;
  plannedDistance: number;
  haltingTime: number;
  highwayCharge: number;
  allowCharge: boolean;
  editableCoordinates: boolean;
};

type BillingsOrderForwardTaxiTaxiAddParams = {
  forwardingId: string;
  billingNodes: BillingsOrderForwardTaxiTaxiAddParamsBillingNode[];
  billingContributions: BillingsOrderForwardTaxiTaxiAddParamsContribution[];
};

export default BillingsOrderForwardTaxiTaxiAddParams;
